import React from 'react';
import { IWebApp } from '../types/telegram';

export const SUPPORT_LINK = process.env.REACT_APP_SUPPORT_LINK || 'https://t.me/RichOne_Club_Menejer';

/**
 * Inside Telegram a t.me link should open in the client, not in a browser tab. Falls back to the
 * anchor's own navigation on older clients that lack `openTelegramLink`.
 */
export const openTelegramLink = (
    webApp: IWebApp | undefined,
    url: string,
    event?: React.MouseEvent<HTMLElement>
) => {
    if (typeof webApp?.openTelegramLink !== 'function') {
        return;
    }

    event?.preventDefault();
    webApp.openTelegramLink(url);
};

/**
 * Opens any URL, event-free (the trigger is a button, not an anchor). A t.me link goes through
 * Telegram's own opener; anything else uses `openLink` inside Telegram, falling back to a plain
 * browser tab on clients that expose neither.
 */
export const openExternalLink = (webApp: IWebApp | undefined, url: string) => {
    if (/^https?:\/\/t\.me\//.test(url) && typeof webApp?.openTelegramLink === 'function') {
        webApp.openTelegramLink(url);
    } else if (typeof webApp?.openLink === 'function') {
        webApp.openLink(url);
    } else {
        window.open(url, '_blank', 'noopener');
    }
};

/** A claimed gift's link — the same opener, kept under the name the gift timeline uses. */
export const openGiftLink = openExternalLink;

/** A filesystem-safe file name derived from a material title, always ending in `.pdf`. */
const pdfFileName = (title: string): string => {
    const base = title.replace(/[^\p{L}\p{N}\-_. ]/gu, '').trim().replace(/\s+/g, '_') || 'material';

    return `${base}.pdf`;
};

/**
 * Downloads a material PDF. On Telegram 8.0+ clients the native download dialog is used; otherwise the
 * file is opened (Telegram's in-app opener, else a plain browser tab) and the client handles it.
 */
export const downloadFile = (webApp: IWebApp | undefined, url: string, title: string) => {
    const fileName = pdfFileName(title);

    if (typeof webApp?.downloadFile === 'function' && webApp?.isVersionAtLeast?.('8.0')) {
        webApp.downloadFile({ url, file_name: fileName });
    } else if (typeof webApp?.openLink === 'function') {
        webApp.openLink(url);
    } else {
        window.open(url, '_blank', 'noopener');
    }
};
